import { render, staticRenderFns } from "./user-inform.vue?vue&type=template&id=99b93d1c&scoped=true"
import script from "./user-inform.vue?vue&type=script&lang=js"
export * from "./user-inform.vue?vue&type=script&lang=js"
import style0 from "./user-inform.vue?vue&type=style&index=0&id=99b93d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b93d1c",
  null
  
)

export default component.exports